var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',_vm._b({ref:"input",staticClass:"input-llood-number",attrs:{"type":"number"},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'el-input',{..._vm.$attrs, ..._vm.$props},false))
}
var staticRenderFns = []

export { render, staticRenderFns }